import { css } from "styled-components";
import { FontMixin } from "../../../../../../../../styles/common/mixins/helpers.styled.js";
import { RadioButtonInput, RadioButtonLabel } from "../../styled.js";
const universalMusicRadioButtonStyles = {
    RadioButtonLabel: ()=>css`
		::after {
			background-color: ${({ theme  })=>theme.colors.grays.darker};
		}
		::before {
			border: 4px solid ${({ theme  })=>theme.colors.white.base};
		}
		${FontMixin({
            height: 'base',
            weight: 'regular'
        })}

		${({ theme  })=>theme.media.phone.only} {
			${FontMixin({
            size: 'medium',
            height: 'base',
            weight: 'medium'
        })}
		}
	`,
    RadioButtonInput: ()=>css`
		&:focus + ${RadioButtonLabel}:before {
			border-color: ${({ theme  })=>theme.colors.white.base};
		}
	`,
    RadioButtonItemWrapper: ()=>css`
		${RadioButtonLabel} {
			${({ theme  })=>theme.media.phone.only} {
				background-color: ${({ theme  })=>theme.colors.white.base};
				color: ${({ theme  })=>theme.colors.grays.dark};
			}
		}

		${RadioButtonInput} {
			${({ theme  })=>theme.media.phone.only} {
				&:checked + ${RadioButtonLabel} {
					background-color: ${({ theme  })=>theme.colors.grays.light};
					color: ${({ theme  })=>theme.colors.grays.darker};
				}
			}
		}
	`
};
export default universalMusicRadioButtonStyles;

//# sourceMappingURL=partnershipsUniversalMusic.js.map